// Question definitions for the SCS "Overall Extent of Exposure" wizard.
//
// Mirrors scsDescriptionOfStudiesQuestions / scsSubjectDispositionQuestions:
// `number` is the stable badge shown in the CSR-style index badge (page order,
// hardcoded — it does not renumber as conditional sections toggle), `text` is
// the fallback wording and `tooltip` holds the ticket INFORMATION/helper text
// (the endpoint returns wording only, no tooltip map).
//
// At runtime the wording is overridden by
// GET /clinical_summaries/safety_summary/questions, keyed by the same attribute
// the answer is stored under. `textKey` names the attribute to read that
// wording from when it differs from the local key — the comparison questions
// (Q3–Q5) are the Description of Studies questions repeated per grouping, so
// they reuse that page's wording and only their badge number changes.

export const SCS_OEE_QUESTIONS = {
  qExposureOtherStudies: {
    number: 1,
    required: true,
    text: "Do you have other completed or ongoing studies to report?",
  },
  qExposureTable: {
    number: 2,
    text: "Select the table you need to discuss.",
  },
  qExposureComparisonType: {
    number: 3,
    text: "What comparison are you planning to make for each group?",
  },
  // Q4 / Q5 below are the Description of Studies branch questions (its Q8 / Q9)
  // shown for the comparison type picked in Q3.
  qNonComparativeGroupNames: {
    number: 4,
    text: "What are the actual names used to describe the treatment/analysis groups in the column headers?",
  },
  qExposureTreatmentGroups: {
    number: 4,
    text: "What are the actual names used to describe the treatment/analysis groups in the column headers? Please define the role for each column name.",
  },
  qExposureComparisonPairs: {
    number: 5,
    text: "Which dose/treatment groups should be compared?",
  },
  qExposureDoseGroups: {
    number: 4,
    text: "Please list the dose group column headers from lowest to highest, starting with Placebo if present.",
  },
};

// Intro line shown above the groupings accordion.
export const SCS_OEE_INTRO_TEXT =
  "We will report all groupings defined in Description of Studies page.";

// Yes / No toggle answers for question 1.
export const SCS_OEE_OTHER_STUDIES_OPTIONS = [
  { label: "Yes", value: true },
  { label: "No", value: false },
];
